<template>
  <div id="app" class="principal">
    <b-navbar
      v-if="currentUser"
      type="dark"
      fixed="top"
      z-index="1030"
      is-transparent
      sticky
    >
      <b-navbar-brand href="#">
        <b-row>
          <b-col>
            <b-button v-b-toggle.menu-lateral variant="success" class="botonAccion ml-5"
              ><i class="fas fa-bars"
            /></b-button>
          </b-col>
        </b-row>
      </b-navbar-brand>
      <b-navbar-nav class="ml-5">
        <b-col>
          <img class="logo" src="./images/dekra.png" />
        </b-col>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-col>
          <p  class="nombre-empleado">
            {{ nombreEmpleado }}
          </p>
        </b-col>
        <b-col class="d-flex align-items-center">
            <notification-bell />
        </b-col>
        <b-nav-item @click.prevent="logOut">
          <font-awesome-icon
            icon="sign-out-alt"
            style="font-size: 15px; margin-top: 10px"
          />
          Salir
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <b-sidebar
      pills
      v-if="currentUser"
      id="menu-lateral"
      title=""
      shadow
      visible
      z-index="10"
      width="200px"
      :no-close-on-route-change="true"
    >
      <b-form-select
        v-model="idiomaSeleccionado"
        :options="optionsIdioma"
        class="mb-0 mt-5 ml-3 mr-1 w-50"
        value-field="item"
        text-field="name"
        size="sm"
        width="20px"
        @change="gestionIdioma()"
        disabled-field="notEnabled"
      ></b-form-select>

      <b-link to="/principal" class="link">
        <p align="left" class="mt-4 ml-4 entradaSidebar" style="font-weight: bold">
          <i class="fas fa-home" style="margin-right: 10px"></i> Home
        </p>
      </b-link>

      <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuTrabajadores
        style="font-weight: bold"
      >
        <i class="fas fa-user" style="margin-right: 17px"></i> Trabajadores
      </h6>
      <b-collapse id="menuTrabajadores">
        <div class="card-body">
          <b-link to="/trabajadores" class="link entradaSidebar">
            <p align="left" class="ml-4">Empleados</p>
          </b-link>
          <b-link to="/externos" class="link entradaSidebar">
            <p align="left" class="ml-4">Externos</p>
          </b-link>
        </div>
      </b-collapse>

      <b-link to="/clientes" class="link"
        v-if="
          currentUser && (currentUser.roles[0] == 'ROLE_SALES' || currentUser.roles[0] == 'ROLE_MANAGER' || currentUser.roles[0] == 'ROLE_FINANCE' || currentUser.roles[0] == 'ROLE_TRAINING' ||
          currentUser.roles[0] == 'ROLE_SUPERADMIN')
        ">
        <p align="left" class="mt-4 ml-4 entradaSidebar" style="font-weight: bold">
          <i class="fas fa-user-plus" style="margin-right: 14px"></i> Clientes
        </p>
      </b-link>

      <h6
        v-if="currentUser && (['ROLE_SUPERADMIN', 'ROLE_SALES', 'ROLE_MANAGER', 'ROLE_SUPERUSER'].includes(currentUser.roles[0]) || currentUser.username === 'A184374')"
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuSales
        style="font-weight: bold"
      >
        <i class="fas fa-file-invoice-dollar" style="margin-right: 17px"></i> Sales
      </h6> 
      <b-collapse id="menuSales" v-if="currentUser && (['ROLE_SUPERADMIN', 'ROLE_SALES', 'ROLE_MANAGER', 'ROLE_SUPERUSER'].includes(currentUser.roles[0]) || currentUser.username === 'A184374')">
        <div class="card-body">
          <b-link to="/ofertas" class="link entradaSidebar">
            <p align="left" class="ml-4">Consulting</p>
          </b-link>
          <b-link to="/opcionales" class="link entradaSidebar">
            <p align="left" class="ml-4">Opcionales</p>
          </b-link>
        </div>
      </b-collapse>

<h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuReferencias
        style="font-weight: bold"
      >
        <i class="fa fa-address-card" style="margin-right: 10px"></i> Referencias
      </h6>
      <b-collapse id="menuReferencias">
        <div class="card-body">
          <b-link to="/proyectos" class="link entradaSidebar"
          v-if="
              currentUser && currentUser.roles[0] !== 'ROLE_EXTERNO'"
            ><p align="left" class="ml-4">Proyectos</p></b-link
          >
        </div>
      </b-collapse>


      <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuMemorias
        style="font-weight: bold"
      >
        <i class="fa fa-file-word-o" style="margin-right: 17px"></i> Memorias
      </h6>
      <b-collapse id="menuMemorias">
        <div class="card-body">
          <b-link
            v-if="
              currentUser && (currentUser.roles[0] == 'ROLE_SALES' || currentUser.roles[0] == 'ROLE_USER' || currentUser.roles[0] == 'ROLE_SUPERUSER' ||
              currentUser.roles[0] == 'ROLE_SUPERADMIN'||currentUser.roles[0] == 'ROLE_MANAGER')
            "
            to="/memoriasrepsol" class="link entradaSidebar">
            <p align="left" class="ml-4">Repsol</p>
          </b-link>
        </div>
      </b-collapse>

      <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuProjects
        style="font-weight: bold"
      >
        <i class="fas fa-tasks" style="margin-right: 14px"></i> Proyectos
      </h6>
      <b-collapse id="menuProjects">
        <div class="card-body">
          <b-link to="/projects" class="link entradaSidebar">
            <p align="left" class="ml-4">Proyectos</p>
          </b-link>
          <b-link to="/horas" class="link entradaSidebar">
            <p align="left" class="ml-4">Imputación Horas</p>
          </b-link>
          <b-link to="/calendar" class="link entradaSidebar">
            <p align="left" class="ml-4">Visualización Horas</p>
          </b-link>
          <b-link to="/pbi/produccionIndividualPersonalizada" class="link entradaSidebar">
            <p align="left" class="ml-4">Produccion Individual</p>
          </b-link>
          <b-link
            v-if="
              currentUser && (currentUser.roles[0] == 'ROLE_TRAINING' || currentUser.roles[0] == 'ROLE_FINANCE' ||
              currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/cursosAmazon"
            class="link entradaSidebar">
            <p align="left" class="ml-4">Cursos Amazon</p>
          </b-link>
        </div>
      </b-collapse>

      <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuFormacion
        style="font-weight: bold"
      >
       
        <i class="fas fa-chalkboard-teacher" style="margin-right: 17px"></i> TMS
      </h6>
      <b-collapse id="menuFormacion">
        <div class="card-body">
         <b-link to="/curso" class="link entradaSidebar">
            <p align="left" class="ml-4">Cursos</p>
          </b-link>
          <b-link to="/catalogo-curso" class="link entradaSidebar">
            <p align="left" class="ml-4">Catálogo</p>
          </b-link>

       
          
          <b-link to="/encuesta-satisfaccion" class="link entradaSidebar">
            <p align="left" class="ml-4">Encuestas</p>
          </b-link>
          <b-link to="/examen-curso" class="link entradaSidebar">
            <p align="left" class="ml-4">Exámenes</p>
          </b-link> <!-- <- FIX -->
         


          
          <b-link
           v-if="currentUser &&  (currentUser.roles[0] == 'ROLE_TRAINING' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN' ||  currentUser.roles[0] == 'ROLE_USER' ||  currentUser.roles[0] == 'ROLE_SUPERUSER' ||  currentUser.roles[0] == 'ROLE_MANAGER')
            "
           to="/participante" class="link entradaSidebar">
            <p align="left" class="ml-4">Participantes</p>
          </b-link>
        </div>
      </b-collapse>

      <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuFinanciero
        style="font-weight: bold"
      >
        <i class="fa fa-eur" aria-hidden="true" style="margin-right: 19px"></i> Financiero
      </h6>
      <b-collapse id="menuFinanciero">
        <div class="card-body">
          <b-link
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/facturacionInforme"
            class="link entradaSidebar">
            <p align="left" class="ml-4">Facturación</p>
          </b-link>

          <b-link
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/facturacionInformeNueva"
            class="link entradaSidebar">
            <p align="left" class="ml-4">Facturación BC</p>
          </b-link>

          <b-link
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/facturacionArchivoNavision"
            class="link entradaSidebar">
            <p align="left" class="ml-4">Archivo BC</p>
          </b-link>

          <h6
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN' ||
                currentUser.roles[0] == 'ROLE_TRAINING')
            "
            class="mt-3 ml-4 entradaSidebar"
            v-b-toggle.menuAmazon
            style="font-weight: bold"
          >
            <i aria-hidden="true" style="margin-right: 0px"></i> Facturación Amazon
          </h6>
          <b-collapse id="menuAmazon">
            <div class="card-body">
              <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN' ||
                    currentUser.roles[0] == 'ROLE_TRAINING')
                "
                to="/facturacionInformation"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Information</p>
              </b-link>
           <!--   <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN' ||
                    currentUser.roles[0] == 'ROLE_TRAINING')
                "
                to="/facturacionSafety"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Safety</p>
              </b-link> -->
            </div>
          </b-collapse>

          <h6
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            class="mt-3 ml-4 entradaSidebar"
            v-b-toggle.menuWIP
            style="font-weight: bold"
          >
            <i aria-hidden="true" style="margin-right: 0px"></i> WIP
          </h6>
          <b-collapse id="menuWIP">
            <div class="card-body">
              <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN')
                "
                to="/provisionInforme"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Provisión</p>
              </b-link>
              <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN')
                "
                to="/desprovisionInforme"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Desprovisión</p>
              </b-link>
            </div>
          </b-collapse>

          <h6
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            class="mt-3 ml-4 entradaSidebar"
            v-b-toggle.menuPOC
            style="font-weight: bold"
          >
            <i aria-hidden="true" style="margin-right: 0px"></i> POC
          </h6>
          <b-collapse id="menuPOC">
            <div class="card-body">
              <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN')
                "
                to="/provisionInformePOC"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Provisión</p>
              </b-link>
              <b-link
                v-if="
                  currentUser &&
                  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                    currentUser.roles[0] == 'ROLE_SUPERADMIN')
                "
                to="/desprovisionInformePOC"
                class="link entradaSidebar">
                <p align="left" class="ml-4">Desprovisión</p>
              </b-link>
            </div>
          </b-collapse>
        </div>
      </b-collapse>

      <h6 class="mt-4 ml-4 entradaSidebar" v-b-toggle.menuPWBI style="font-weight: bold">
        <i class="fas fa-info-circle" aria-hidden="true" style="margin-right: 19px"></i> Informes PBI
      </h6>
      <b-collapse id="menuPWBI">
        <div class="card-body">
          <h6 class="mt-3 ml-4 entradaSidebar" v-b-toggle.menuCalidad style="font-weight: bold">
            <i aria-hidden="true" style="margin-right: 0px"></i> Calidad
          </h6>
          <b-collapse id="menuCalidad">
            <div class="card-body">
              <b-link to="/pbi/calidad" class="link entradaSidebar">
                <p align="left" class="ml-4">Calidad DAT</p>
              </b-link>
              <b-link to="/pbi/encuestas" class="link entradaSidebar">
                <p align="left" class="ml-4">Encuestas</p>
              </b-link>
            </div>
          </b-collapse>

          <h6 class="mt-3 ml-4 entradaSidebar" v-b-toggle.contabilidad style="font-weight: bold">
            <i aria-hidden="true" style="margin-right: 0px"></i> Contabilidad
          </h6>
          <b-collapse id="contabilidad">
            <div class="card-body">
              <b-link to="/pbi/contabilidad" class="link entradaSidebar">
                <p align="left" class="ml-4">Contabilidad DAT</p>
              </b-link>
              <b-link to="/pbi/horas" class="link entradaSidebar">
                <p align="left" class="ml-4">Horas DAT</p>
              </b-link>
              <b-link to="/pbi/aging" class="link entradaSidebar">
                <p align="left" class="ml-4">Facturas Pendientes</p>
              </b-link>
            </div>
          </b-collapse>

          <h6 class="mt-3 ml-4 entradaSidebar" v-b-toggle.manuProduccionPBI style="font-weight: bold">
            <i aria-hidden="true" style="margin-right: 0px"></i> Producción DAT
          </h6>
          <b-collapse id="manuProduccionPBI">
            <div class="card-body">
              <b-link to="/pbi/produccion" class="link entradaSidebar">
                <p align="left" class="ml-4">Producción DAT</p>
              </b-link>
              <b-link to="/pbi/prevision" class="link entradaSidebar">
                <p align="left" class="ml-4">Previsión Ventas DAT</p>
              </b-link>
              <b-link to="/pbi/horas" class="link entradaSidebar">
                <p align="left" class="ml-4">Horas DAT</p>
              </b-link>
               <b-link to="/pbi/facturasPendientes" class="link entradaSidebar">
                <p align="left" class="ml-4">Facturas Pendientes</p>
              </b-link>
              <b-link to="/pbi/tasaOcupacion" class="link entradaSidebar">
                <p align="left" class="ml-4">Tasa Ocupación</p>
              </b-link> 
              <b-link to="/pbi/lideresServicio" class="link entradaSidebar">
                <p align="left" class="ml-4">Lideres Servicio</p>
              </b-link>
                <b-link to="/pbi/resumenEjecutivoPersonalizado" class="link entradaSidebar">
                <p align="left" class="ml-4">Resumen ejecutivo Personalizado</p>
              </b-link>
              <b-link to="/pbi/resumenEjecutivo" class="link entradaSidebar">
                <p align="left" class="ml-4">Resumen ejecutivo</p>
              </b-link>
              <b-link to="/pbi/produccion-individual" class="link entradaSidebar">
                <p align="left" class="ml-4">Producción Individual DAT</p>
              </b-link>
                <b-link to="/pbi/apoyoConsultoria" class="link entradaSidebar">
                <p align="left" class="ml-4">Apoyo Consultoria</p>
              </b-link>
            </div>
          </b-collapse>
           <h6 class="mt-3 ml-4 entradaSidebar" v-b-toggle.menuRentabilidad style="font-weight: bold">
            <i aria-hidden="true" style="margin-right: 0px"></i> Rentabilidad
          </h6>
          <b-collapse id="menuRentabilidad">
            <div class="card-body">
                        
              <b-link to="/pbi/rentabilidadProyecto" class="link entradaSidebar">
                <p align="left" class="ml-4">Rentabilidad Proyecto</p>
              </b-link>        
              <b-link to="/pbi/rentabilidadProyectoMensual" class="link entradaSidebar">
                <p align="left" class="ml-4">Rentabilidad Proyecto Mensual</p>
              </b-link>
               <b-link to="/pbi/costePersonal" class="link entradaSidebar">
                <p align="left" class="ml-4">Informe Mensual Coste Personal Proyecto</p>
              </b-link>
            </div>
          </b-collapse>

          <h6 class="mt-3 ml-4 entradaSidebar" v-b-toggle.menuTmsPBI style="font-weight: bold">
            <i aria-hidden="true" style="margin-right: 0px"></i> TMS
          </h6>
          <b-collapse id="menuTmsPBI">
            <div class="card-body">
              <b-link to="/pbi/tms" class="link entradaSidebar">
                <p align="left" class="ml-4">TMS</p>
              </b-link>
            </div>
          </b-collapse>
        </div>
      </b-collapse>
 <h6
        class="mt-4 ml-4 entradaSidebar"
        v-b-toggle.menuInformeProjects
        style="font-weight: bold"
      >
        <i class="fas fa-file" style="margin-right: 19px"></i> Informes
      </h6>
      <b-collapse id="menuInformeProjects">
        <div class="card-body">
         <!-- <b-link
            v-if="
              currentUser && (currentUser.roles[0] == 'ROLE_MANAGER' ||
              currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/projectsInforme"
            class="link entradaSidebar"
            ><p align="left" class="ml-4">Encuesta</p></b-link
          >-->
         
          <b-link
            v-if="
              currentUser &&
              (currentUser.roles[0] == 'ROLE_MANAGER' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN' || currentUser.roles[0] == 'ROLE_FINANCE' || currentUser.roles[0] == 'ROLE_TRAINING')
            "
            to="/projectsSesameInforme"
            class="link entradaSidebar"
            ><p align="left" class="ml-4">Horas Sesame</p></b-link
          >
          <b-link
            v-if="currentUser &&  (currentUser.roles[0] == 'ROLE_FINANCE' ||
                currentUser.roles[0] == 'ROLE_SUPERADMIN')
            "
            to="/projectsNavisionInforme"
            class="link entradaSidebar"
            ><p align="left" class="ml-4">Datos Navision</p></b-link
          >
          <b-link
            v-if="currentUser && currentUser.roles[0] == 'ROLE_SUPERADMIN' 
            "
            to="/projectCategoriaInforme"
            class="link entradaSidebar"
            ><p align="left" class="ml-4">Categoria Empleado</p></b-link
          >
          <b-link
            v-if="currentUser && currentUser.roles[0] == 'ROLE_SUPERADMIN'"
            to="/capacidadConsultor"
            class="link entradaSidebar"
            ><p align="left" class="ml-4">Capacidad Consultor</p></b-link
          >
          <b-link
            v-if="currentUser && currentUser.roles[0] == 'ROLE_SUPERADMIN'"
            to="/configuracion-pbi"
            class="link entradaSidebar"
            ><p align="left" class="ml-4" style="color: #506a5b; font-weight: bold;"><i class="fas fa-cog mr-1"></i> Configurar URLs PBI</p></b-link
          >
        </div>
      </b-collapse>

    </b-sidebar>

    <div class="central">
      <div class="contenedor">
          <router-view :key="$route.name"></router-view> 
       <!--  <router-view :key="$route.fullPath"></router-view> -->
      </div>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";
import NotificationBell from "@/components/NotificationBell.vue";

export default {
  components: {
    NotificationBell
  },
  data() {
    return {
      nombreEmpleado: "",
      idiomaSeleccionado: "ESP",
      //pathReports: 'C:/workspace/Dekra/',

      pathReports: "/srv/dekra/report/",
      optionsIdioma: [
        { item: "ESP", name: "Español" },
        { item: "ENG", name: "Inglés" },
      ],
      optionsClaseProyectoESP: [
        { text: "Formación", value: "TRAINING" },
        { text: "Consultoría", value: "CONSULTING" },
        { text: "Ensayos", value: "TESTING" },
        { text: "Open Training", value: "OPENTRAINING" },
        { text: "E-Learning", value: "ELEARNING" },
      ],
      optionsClaseProyectoENG: [
        { text: "Training", value: "TRAINING" },
        { text: "Consultancy", value: "CONSULTING" },
        { text: "Testing", value: "TESTING" },
        { text: "Open Training", value: "OPENTRAINING" },
        { text: "E-Learning", value: "ELEARNING" },
      ],
      optionsTipoProyectoEsp: [
        {
          value: "Descarbonización",
          text: "Descarbonización",
        },
        {
          value: "Sostenibilidad Activos Inmobiliarios",
          text: "Sostenibilidad Activos Inmobiliarios",
        },
        {
          value: "Consultoría Ambiental",
          text: "Consultoría Ambiental",
        },
        {
          value: "Estrategia ESG",
          text: "Estrategia ESG",
        },
        {
          value: "Accidentes graves - SEVESO",
          text: "Accidentes graves - SEVESO",
        },

        {
          value:
            "ATEX (Clasificación de zonas/Evaluación de riesgos de explosión/Inspección de equipos)",
          text:
            "ATEX (Clasificación de zonas/Evaluación de riesgos de explosión/Inspección de equipos)",
        },
        { value: "PSM-OPS", text: "PSM-OPS" },
        {
          value: "CRH-Vent sizing",
          text: "CRH-Vent sizing",
        },

        {
          value: "Ensayo",
          text: "Ensayo",
        },
        { value: "Formación", text: "Formación" },
        {
          value: "Occupational safety",
          text: "Occupational safety",
        },

        { value: "PHA", text: "PHA" },

        {
          value: "Seguridad Funcional - SIL",
          text: "Seguridad Funcional - SIL",
        },

        {
          value: "Consultoría en transporte y logística",
          text: "Consultoría en transporte y logística",
        },
        {
          value: "Seguridad de máquinas-activos",
          text: "Seguridad de máquinas-activos",
        },
        {
          value: "OSR",
          text: "OSR",
        },

        { value: "Otro", text: "Otro" },
      ],
      optionsSectoresEsp: [
        { value: "Administración pública", text: "Administración pública" },
        { value: "Automoción", text: "Automoción" },
        { value: "Aeroespacial y Defensa", text: "Aeroespacial y Defensa" },
        { value: "Bienes de consumo", text: "Bienes de consumo" },
        { value: "Consultores", text: "Consultores" },
        { value: "Cosmética", text: "Cosmética" },

        {
          value: "Energía / Servicios / Residuos",
          text: "Energía / Servicios / Residuos",
        },
        { value: "EPC", text: "EPC" },
        { value: "Fabricantes de equipos", text: "Fabricantes de equipos" },
        { value: "Farmacéutico", text: "Farmacéutico" },
        {
          value: "Industria Papelera/Celulosa",
          text: "Industria Papelera/Celulosa",
        },
        {
          value: "Materiales de construcción / Vidrio",
          text: "Materiales de construcción / Vidrio",
        },
        { value: "Oil & Gas", text: "Oil & Gas" },
        { value: "Químico", text: "Químico" },

        { value: "Otros", text: "Otros" },
      ],
      optionsTipoProyectoEng: [
        {
          value: "Energy Consulting",
          text: "Energy Consulting",
        },
        {
          value: "Sustainability strategy for Real Estate",
          text: "Sustainability strategy for Real Estate",
        },
        {
          value: "Enviromental Advisory",
          text: "Enviromental Advisory",
        },
        {
          value: "ESG Strategy",
          text: "ESG Strategy",
        },

        {
          value: "CRH-Vent sizing",
          text: "CRH-Vent sizing",
        },

        {
          value: "Major Accidents Hazards – SEVESO",
          text: "Major Accidents Hazard – SEVESO",
        },

        { value: "Functional Safety - SIL", text: "Functional Safety - SIL" },
        {
          value: "HAC/Explosion Risk Assessment / Electrical Equipment Inspection",
          text: "HAC/Explosion Risk Assessment / Electrical Equipment Inspection",
        },
        { value: "Occupational safety", text: "Occupational safety" },
        {
          value: "Transportation and logistics advisory services",
          text: "Transportation and logistics advisory services",
        },
        {
          value: "Machinery Safety and Asset Integrity Management (AIM)",
          text: "Machinery Safety and Asset Integrity Management (AIM)",
        },

        { value: "PHA", text: "PHA" },
        { value: "OSR", text: "OSR" },
        { value: "PSM-OPS", text: "PSM-OPS" },
        //  { value: 'PSM Audit', text: 'PSM Audit' },

        //  {
        //value: 'Risk Assessment (fire and explosion)',
        //text: 'Risk Assessment (fire and explosion)'
        //},
        { value: "Testing", text: "Testing" },
        { value: "Training", text: "Training" },
        { value: "Other", text: "Other" },
      ],
      optionsSectoresEng: [
        { value: "Automotive", text: "Automotive" },
        { value: "Aerospace & Defense", text: "Aerospace & Defense" },
        {
          value: "Building Materials / Glass",
          text: "Building Materials / Glass",
        },
        { value: "Chemicals", text: "Chemicals" },
        { value: "Consultants", text: "Consultants" },
        { value: "Cosmetic / Healthcare", text: "Cosmetic / Healthcare" },
        { value: "Consumer goods", text: "Consumer goods" },
        {
          value: "Energy / Utilities / Waste",
          text: "Energy / Utilities / Waste",
        },
        { value: "EPC", text: "EPC" },
        { value: "Equipment Manufacturer", text: "Equipment Manufacturer" },
        {
          value: "Manufacture of paper and paperboard",
          text: "Manufacture of paper and paperboard",
        },
        { value: "Oil & Gas", text: "Oil & Gas" },

        { value: "Pharmaceuticals", text: "Pharmaceuticals" },

        { value: "Public Sector", text: "Public Sector" },
        { value: "Others", text: "Others" },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    gestionIdioma() {
      this.$router.push("/principal");
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    catchError(error) {
      console.error("Error al obtener los clientes:", error);
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        this.$store.dispatch("auth/logout");
        this.$router.push("/login");
      } else {
        this.showMsgBoxConfirm(
          error.response.data.message + " - Debug: " + error.response.data.debugMessage,
          "danger",
          "Error"
        );
      }
    },
    showMsgBoxConfirm(msg, vari, title, size) {
      this.$bvModal
        .msgBoxOk(msg, {
          title: title,
          size: size,
          buttonSize: "sm",
          okVariant: vari,
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.msgValue = value;
        });
    },
 async cargarNombreEmpleadoNav() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.username) return;
console.log("api1 baseURL:", api1.defaults.baseURL);
// Debe imprimir http://localhost:9001 en dev

    const { data } = await api1.get(
      `/api/dekra/v204/empleado/username/${encodeURIComponent(user.username)}`
    );

    this.nombreEmpleado = data?.nombre || "";
  } catch (error) {
    console.error("Error al obtener el empleado:", error);

    // Si ya tienes los 401/403 gestionados en el interceptor de api1,
    // esto normalmente no hará falta. Lo dejo por si quieres mantenerlo.
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
      return;
    }

    const msg =
      error?.response?.data?.message ||
      "No se pudo cargar el nombre del empleado.";
    const dbg = error?.response?.data?.debugMessage || "";
    this.showMsgBoxConfirm(`${msg}${dbg ? " - Debug: " + dbg : ""}`, "danger", "Error");
  }
},
  },
  mounted() {},
};
</script>
<style>
@font-face {
  font-family: "Sans";
  src: local("Sans"), url(./fonts/ProductSans-Regular.ttf) format("truetype");
}
.principal {
  font-family: "Sans";
  color: #506a5b;
}

.crudform {
  border-radius: 5px;
  padding-top: 2px;
  padding-right: 2px;
  padding-bottom: 2px;
  padding-left: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);
}
.card-login {
  max-width: 400px;
  background-color: #f7f7f7;
  margin: 150px auto 25px;
  border-radius: 20px;
  border-color: #dddddd;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);
}
.logo {
  max-width: 130px;
  margin: 0px auto 0px;
}
.link:hover {
  text-decoration: none;
}
.navbar {
  background-color: #017d41;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);
  z-index: 100;
}
.texto-nav {
  color: #ffffff;
}
.entradaSidebar {
  font-size: 90%;
  color: #506a5b;
}
.entradaSidebar:hover {
  font-size: 90%;
  color: #111111;
}

.botonAccion {
  border-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);
}
.contenedor {
  margin: 0px 30px 0px 250px;
  max-width: 80%;
}
.nombre-empleado{
  font-size: 20px;
  color: white;
  margin-right: 40px;
  margin-top: 10px;

  white-space: nowrap;      /* evita salto de línea */
  overflow: hidden;         /* oculta lo que sobra */
  text-overflow: ellipsis;  /* muestra ... si no cabe */
  max-width: 320px;         /* ajusta este valor a tu gusto */
  display: block;
}

</style>
